{
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.body.long-read": [
    {
      "type": 0,
      "value": "You just spent some quality time on a long page. Next time you need to revisit it, Rovo can summarize the key points in seconds."
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.body.page-created": [
    {
      "type": 0,
      "value": "You just created a page in Confluence. Want to take it even further? Rovo can give you instant feedback on clarity, structure, and completeness - in seconds."
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.body.page-watched": [
    {
      "type": 0,
      "value": "Watching pages is a great way to stay in the loop. But instead of sifting through every notification, let Rovo give you a quick AI-powered catch-up on what changed."
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.cta.long-read": [
    {
      "type": 0,
      "value": "Try AI summary"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.cta.page-created": [
    {
      "type": 0,
      "value": "Review my page with Rovo"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.cta.page-watched": [
    {
      "type": 0,
      "value": "Try AI catch-up"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.footer.unsubscribe": [
    {
      "type": 1,
      "value": "link"
    },
    {
      "type": 0,
      "value": " to opt out of future emails like this."
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.footer.unsubscribe.cta": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.heading.long-read": [
    {
      "type": 0,
      "value": "Deep reader alert!"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.heading.page-created": [
    {
      "type": 0,
      "value": "Nice work on your new page!"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.heading.page-watched": [
    {
      "type": 0,
      "value": "You're watching a page — nice!"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.preheader.long-read": [
    {
      "type": 0,
      "value": "Review key points in seconds with AI summary"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.preheader.page-created": [
    {
      "type": 0,
      "value": "Get instant feedback on clarity and structure from Rovo"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.preheader.page-watched": [
    {
      "type": 0,
      "value": "Get AI-powered summaries instead of notification noise"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.rovo-prompt.long-read": [
    {
      "type": 0,
      "value": "Summarize the key points of this page"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.rovo-prompt.page-created": [
    {
      "type": 0,
      "value": "Review this page for clarity, tone, and structure"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.rovo-prompt.page-watched": [
    {
      "type": 0,
      "value": "Notify me when this page is updated"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.subject.long-read": [
    {
      "type": 0,
      "value": "That was a long read — here's a shortcut for next time"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.subject.page-created": [
    {
      "type": 0,
      "value": "You just published a page - want a second opinion?"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.subject.page-watched": [
    {
      "type": 0,
      "value": "A smarter way to stay updated on pages you watch"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.body.long-read": [
    {
      "type": 0,
      "value": "Get the key points, decisions, and action items from any page — without re-reading the whole thing."
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.body.page-created": [
    {
      "type": 0,
      "value": "Ask Rovo to review your page for clarity, tone, and structure. It's like having an editor on standby."
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.body.page-watched": [
    {
      "type": 0,
      "value": "Rovo summarizes all recent changes across the pages you watch, so you can stay informed without the notification noise."
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.title.long-read": [
    {
      "type": 0,
      "value": "Summarize any page with AI"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.title.page-created": [
    {
      "type": 0,
      "value": "Get instant feedback from Rovo"
    }
  ],
  "cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.title.page-watched": [
    {
      "type": 0,
      "value": "Get an AI catch-up"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta1.button.go-to-content-type.link-name": [
    {
      "type": 0,
      "value": "Go to "
    },
    {
      "type": 1,
      "value": "contentType"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta1.button.view-more-insights.link-name": [
    {
      "type": 0,
      "value": "View more insights"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta2-template-link-name": [
    {
      "type": 0,
      "value": "Try template"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta2-template-name": [
    {
      "type": 0,
      "value": "Meeting Notes"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.first-line-with-content-type": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "contentType"
    },
    {
      "type": 0,
      "value": " just got its first view"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.second-line.line1": [
    {
      "type": 0,
      "value": "Your work is already helping your team stay on the same page."
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.second-line.line2": [
    {
      "type": 0,
      "value": "To keep the collaboration momentum going, many teams use Confluence for meeting agendas and notes to make shared decisions easy to reference."
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.footer.line-1.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. 341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.footer.line-2.unsubscribe.cta": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.footer.line-2.with-unsubscribe-cta": [
    {
      "type": 1,
      "value": "link"
    },
    {
      "type": 0,
      "value": " to opt out of future emails like this."
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template-template.email.body.img.alt": [
    {
      "type": 0,
      "value": "Image depicting a "
    },
    {
      "type": 1,
      "value": "contentType"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template-template.email.header.img.alt": [
    {
      "type": 0,
      "value": "Confluence logo"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template-template.email.meeting-notes-template.img.alt": [
    {
      "type": 0,
      "value": "Meeting notes template preview"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template-template.email.page-icon.img.alt": [
    {
      "type": 0,
      "value": "Page icon"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.content-type.blog-post": [
    {
      "type": 0,
      "value": "blog post"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.content-type.live-page": [
    {
      "type": 0,
      "value": "live page"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.content-type.page": [
    {
      "type": 0,
      "value": "page"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.subject": [
    {
      "type": 0,
      "value": "You just got your first view ever!"
    }
  ],
  "cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.blogpost": [
    {
      "type": 0,
      "value": "blog post"
    }
  ],
  "cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.database": [
    {
      "type": 0,
      "value": "database"
    }
  ],
  "cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.direct.anonymous": [
    {
      "type": 0,
      "value": "There's a new reaction to your "
    },
    {
      "type": 1,
      "value": "contentType"
    }
  ],
  "cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.direct.first-reaction": [
    {
      "type": 1,
      "value": "reactor"
    },
    {
      "type": 0,
      "value": " reacted to your "
    },
    {
      "type": 1,
      "value": "contentType"
    }
  ],
  "cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.direct.second-reaction": [
    {
      "type": 1,
      "value": "reactor"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "secondReactor"
    },
    {
      "type": 0,
      "value": " reacted to your "
    },
    {
      "type": 1,
      "value": "contentType"
    }
  ],
  "cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.direct.third-reaction-or-more": [
    {
      "type": 1,
      "value": "reactor"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " other"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " others"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "numberOfOtherReactors"
    },
    {
      "type": 0,
      "value": " reacted to your "
    },
    {
      "type": 1,
      "value": "contentType"
    }
  ],
  "cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.live-doc": [
    {
      "type": 0,
      "value": "live doc"
    }
  ],
  "cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.page": [
    {
      "type": 0,
      "value": "page"
    }
  ],
  "cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.watching.anonymous": [
    {
      "type": 0,
      "value": "There's a new reaction to a "
    },
    {
      "type": 1,
      "value": "contentType"
    }
  ],
  "cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.watching.first-reaction": [
    {
      "type": 1,
      "value": "reactor"
    },
    {
      "type": 0,
      "value": " reacted to a "
    },
    {
      "type": 1,
      "value": "contentType"
    }
  ],
  "cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.watching.second-reaction": [
    {
      "type": 1,
      "value": "reactor"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "secondReactor"
    },
    {
      "type": 0,
      "value": " reacted to a "
    },
    {
      "type": 1,
      "value": "contentType"
    }
  ],
  "cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.watching.third-reaction-or-more": [
    {
      "type": 1,
      "value": "reactor"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " other"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " others"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "numberOfOtherReactors"
    },
    {
      "type": 0,
      "value": " reacted to a "
    },
    {
      "type": 1,
      "value": "contentType"
    }
  ],
  "cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.whiteboard": [
    {
      "type": 0,
      "value": "whiteboard"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion-email.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.button-text": [
    {
      "type": 0,
      "value": "Create meeting notes"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.description": [
    {
      "type": 0,
      "value": "Share goals, set context, and save time with a meeting notes template."
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.footer.office-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.header": [
    {
      "type": 0,
      "value": "Keep meetings aligned and actionable"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.header-image.alt-text": [
    {
      "type": 0,
      "value": "Atlassian Confluence logo"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.main-image.alt-text": [
    {
      "type": 0,
      "value": "Meeting notes illustration showing document with highlighted content"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.meeting-notes-image.alt-text": [
    {
      "type": 0,
      "value": "Meeting notes"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.meeting-notes-text": [
    {
      "type": 0,
      "value": "Meeting notes"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.unsubscribe-link-text": [
    {
      "type": 0,
      "value": "If you no longer wish to receive these emails, please update your preferences or unsubscribe "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "here"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.message-template.email.subject": [
    {
      "type": 0,
      "value": "Save time with a Confluence meeting notes template"
    }
  ],
  "cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.hello": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.part1": [
    {
      "type": 0,
      "value": "Your teammates are using Confluence to share project context, capture decisions, and more in "
    },
    {
      "type": 1,
      "value": "projectName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.part2": [
    {
      "type": 0,
      "value": "Here's what they've recently linked to your Jira project:"
    }
  ],
  "cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your team in "
    },
    {
      "type": 1,
      "value": "projectName"
    },
    {
      "type": 0,
      "value": " is using Confluence for project docs--see what they’ve added"
    }
  ],
  "cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.message-template.footer.text": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Cloud"
    }
  ],
  "cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.test-message.email.body.button-cta": [
    {
      "type": 0,
      "value": "Open Confluence"
    }
  ],
  "cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.test-message.email.body.signoff": [
    {
      "type": 0,
      "value": "See what else is happening across your company:"
    }
  ],
  "confluence-personalized-use-case-expansion.first.body": [
    {
      "type": 0,
      "value": "Create your first page"
    }
  ],
  "confluence-personalized-use-case-expansion.first.cta": [
    {
      "type": 0,
      "value": "Create a page"
    }
  ],
  "confluence-personalized-use-case-expansion.first.title": [
    {
      "type": 0,
      "value": "Get started with Confluence"
    }
  ],
  "confluence-reactivate-inactive-link-paste-in-jira-notif.action.text": [
    {
      "type": 0,
      "value": "View in Confluence"
    }
  ],
  "confluence-reactivate-inactive-link-paste-in-jira-notif.message.body": [
    {
      "type": 0,
      "value": "A Confluence page was shared with you in Jira"
    }
  ],
  "confluence-reminder.cta.button": [
    {
      "type": 0,
      "value": "Accept invite"
    }
  ],
  "confluence-reminder.customer-logos.alt": [
    {
      "type": 0,
      "value": "Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"
    }
  ],
  "confluence-reminder.email.subject": [
    {
      "type": 0,
      "value": "Reminder: "
    },
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " invited you to collaborate in Confluence"
    }
  ],
  "confluence-reminder.footer.address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "confluence-reminder.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "confluence-reminder.inviter.avatar.alt": [
    {
      "type": 0,
      "value": "Profile photo of "
    },
    {
      "type": 1,
      "value": "inviterName"
    }
  ],
  "confluence-reminder.main.heading": [
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " invited you to join Confluence"
    }
  ],
  "confluence-reminder.product.description": [
    {
      "type": 0,
      "value": "Plan projects, run meetings, and brainstorm ideas with your team—all in one place."
    }
  ],
  "confluence-reminder.redacted.heading": [
    {
      "type": 0,
      "value": "Reminder: Join your team in Confluence"
    }
  ],
  "confluence-reminder.redacted.subject": [
    {
      "type": 0,
      "value": "Reminder: Join your team in Confluence"
    }
  ],
  "confluence-reminder.social-proof.text": [
    {
      "type": 1,
      "value": "numberOfCustomers"
    },
    {
      "type": 0,
      "value": " customers use "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " to move work forward"
    }
  ],
  "confluence.fastAndSnappy.survey.question": [
    {
      "type": 0,
      "value": "To what extent do you agree or disagree with the following statement?"
    }
  ],
  "confluence.fastAndSnappy.survey.score-subtext.neutral": [
    {
      "type": 0,
      "value": "Neutral"
    }
  ],
  "confluence.fastAndSnappy.survey.score-subtext.strongly-agree": [
    {
      "type": 0,
      "value": "Strongly agree"
    }
  ],
  "confluence.fastAndSnappy.survey.score-subtext.strongly-disagree": [
    {
      "type": 0,
      "value": "Strongly disagree"
    }
  ],
  "confluence.fastAndSnappy.survey.statement": [
    {
      "type": 0,
      "value": "Confluence feels fast and snappy."
    }
  ],
  "confluence.lovability.survey.new-question": [
    {
      "type": 0,
      "value": "How much do you love using Confluence?"
    }
  ],
  "confluence.lovability.survey.question": [
    {
      "type": 0,
      "value": "To what extent do you agree or disagree with the following statement?"
    }
  ],
  "confluence.lovability.survey.score-subtext.neutral": [
    {
      "type": 0,
      "value": "Neutral"
    }
  ],
  "confluence.lovability.survey.score-subtext.not-at-all": [
    {
      "type": 0,
      "value": "Not at all"
    }
  ],
  "confluence.lovability.survey.score-subtext.very-much": [
    {
      "type": 0,
      "value": "Very much"
    }
  ],
  "confluence.lovability.survey.statement": [
    {
      "type": 0,
      "value": "Confluence is a product I love using."
    }
  ],
  "post-office-team.confluence-reactivate-inactive-link-paste-in-jira-email.atlassian-logo": [
    {
      "type": 0,
      "value": "Atlassian Logo"
    }
  ],
  "post-office.confluence-connect-3p-tools-nudge.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.confluence-connect-3p-tools-nudge.heading": [
    {
      "type": 0,
      "value": "See more at a glance"
    }
  ],
  "post-office.confluence-connect-3p-tools-nudge.modal.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.confluence-connect-3p-tools-nudge.modal.subtitle": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bring your team’s work"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " into Confluence pages with rich, interactive previews – no tab-switching needed."
    }
  ],
  "post-office.confluence-connect-3p-tools-nudge.modal.teammates.empty": [
    {
      "type": 0,
      "value": "Teams stay in sync by seeing live updates directly in Confluence."
    }
  ],
  "post-office.confluence-connect-3p-tools-nudge.modal.teammates.few": [
    {
      "type": 0,
      "value": "Your team is already using "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " to work smarter."
    }
  ],
  "post-office.confluence-connect-3p-tools-nudge.modal.teammates.lots": [
    {
      "type": 0,
      "value": "🙌 "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "50+ teammates"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " already connected "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " to Confluence."
    }
  ],
  "post-office.confluence-connect-3p-tools-nudge.modal.teammates.many": [
    {
      "type": 0,
      "value": "🙌 "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "numTeammates"
        },
        {
          "type": 0,
          "value": " teammates"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " already connected "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " to Confluence."
    }
  ],
  "post-office.confluence-connect-3p-tools-nudge.modal.title": [
    {
      "type": 0,
      "value": "Connect your most-used apps"
    }
  ],
  "post-office.confluence-connect-3p-tools-nudge.multi-app-body": [
    {
      "type": 0,
      "value": "Connect your apps to embed rich links in this space."
    }
  ],
  "post-office.confluence-connect-3p-tools-nudge.multi-app.call.to.action": [
    {
      "type": 0,
      "value": "Connect apps"
    }
  ],
  "post-office.confluence-connect-3p-tools-nudge.single-app-body": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " to embed rich links in this space."
    }
  ],
  "post-office.confluence-connect-3p-tools-nudge.single-app.call.to.action": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ]
}